import axios from 'axios';
import {
  QueryClient,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import { GetTeamLeadersKey } from '../queries/useGetTeamLeaders';

export const deleteTeamLeader = async (
  teamLeaderId: number,
  teamId: number,
) => {
  return axios.post(`/api/teams/un-assign-user-from-team`, {
    id: teamLeaderId,
    teamId,
  });
};

export const useDeleteTeamLeaderMutation = (teamId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (teamLeaderId: number) =>
      deleteTeamLeader(teamLeaderId, teamId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GetTeamLeadersKey],
      });
    },
  });
};
